<script setup lang="ts">
import type { ParticipantPage } from "~/types/participantStatus";
import { useAuthParticipent } from "~/store/authParticipants";
import { useParticipantHeartbeat } from "~/composables/useParticipantHeartbeat";

/**
 * Checks a signer or witness in on their notary's status badge from whichever
 * page of the session they are on, once they have logged in with their code.
 */
const route = useRoute();
const auth = useAuthParticipent();

const PAGES: Record<string, ParticipantPage> = {
  "": "onboarding",
  auth: "authentication",
  details: "authentication",
  kba: "authentication",
  questions: "authentication",
  preview: "preview",
  "waiting-room": "waiting_room",
  room: "room",
  denied: "denied",
  download: "complete",
  switch: "complete",
};

const page = computed<ParticipantPage | null>(() => {
  const match = route.path.match(/^\/sessions\/[^/]+\/(?:client|witness)\/[^/]+\/?([^/?#]*)/);
  return match ? (PAGES[match[1]] ?? null) : null;
});

const participantId = computed(() =>
  auth.user?.id && auth.user.id === route.params.user_id ? (auth.user.id as string) : null,
);

useParticipantHeartbeat(participantId, page);
</script>

<template>
  <span hidden />
</template>
